import '@/styles/global.css';

import * as Sentry from '@sentry/react';
import { NuqsAdapter } from 'nuqs/adapters/react';

import { SPALayout } from '@crehana/layouts/spa/layout-with-centralized';

import { AddBaseFunctionality } from '@/shared/components/add-base-functionality';
import { Outlet, useParams } from '@/shared/modern-router';

import { HanaFloatingChatLazy } from '@crehana/hana-ai/floating-chat';

const App = () => {
  const { slug } = useParams();

  return (
    <SPALayout sentryInstance={Sentry} organizationSlug={slug as string}>
      <NuqsAdapter>
        <Outlet />
        <HanaFloatingChatLazy />
      </NuqsAdapter>
      <AddBaseFunctionality />
    </SPALayout>
  );
};

export default App;
